import { Controller } from "stimulus";

export default class extends Controller {
  private readonly errorMessageClass = "invalid-feedback";

  validate(event) {
    const input = event.target;
    const maxLength = input.dataset.maxLength[0];

    if (maxLength) {
      this.validateMaxLength(input);
    }
  }

  validateMaxLength(input) {
    const errorMaxLength = input.dataset.maxLengthError;
    const lengthInput = input.value;
    const maxLength = parseInt(input.dataset.maxLength, 10);

    const oldError = input.parentNode.querySelector(
      "[data-error-for=maxLength]"
    );

    if (oldError) {
      oldError.remove();
    }

    if (lengthInput.length >= maxLength) {
      const inputError = document.createElement("div");

      inputError?.classList.add(this.errorMessageClass);
      inputError.setAttribute("data-error-for", "maxLength");
      inputError.innerHTML = errorMaxLength;

      input.parentNode.insertBefore(inputError, input.nextSibling);
    }
  }
}
